import React, { useState, useEffect } from "react"
import Select from 'react-select';
import { useParams } from "react-router-dom";


import API from '../../tools/API';
import style from './Modal.module.scss';
import { SinglePoll, Poll, PollData, SingleSetting } from '../../tools/interfaces';
import { SingleSelectedChannel } from '../../tools/interfaces'

interface Props {
    openModal: (arg: boolean) => void,
    appId: number,
    settingList: Array<SingleSetting>,
    editModal?: Poll
}

const EditPollModal: React.FC<Props> = ({ openModal, appId, settingList, editModal }) => {
    const { id } = useParams();

    const [error, setError] = useState<string | null>(null);

    const [selectedSetting, setSelectedSetting] = useState<SingleSelectedChannel | null>(null);

    const [settingArr, setSettingArr] = useState<Array<SingleSelectedChannel>>([]);

    const [pollData, setPollData] = useState<PollData | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const [poll, setPoll] = useState<SinglePoll>(
        {
            dateFrom: '',
            dateTo: '',
            votingFrom: '',
            votingTo: '',
            name: '',
            categoryId: parseInt(id as string),
            appId: appId,
            settingId: settingList[0].id,
            id: editModal?.id
        }
    );

    useEffect(() => {
        if (editModal) {
            setPoll({
                ...poll,
                ...editModal,
                votingFrom: editModal.votingFrom,
                votingTo: editModal.votingTo,
            })
        }
        if (poll.id) {
            API.getSinglePoll(String(poll.id)).then((res) => {
                setPollData(res?.data.data);
            })
        }
        if (pollData) {
            setPoll({
                ...poll,
                dateFrom: pollData.dateFrom,
                dateTo: pollData.dateTo,
                settingId: pollData.settingId
            })
        }
        if (settingList) {
            const mappedSettingList = settingList.map((el: SingleSetting) => {
                return (
                    {
                        value: el.id,
                        label: el.name
                    }
                )
            })
            setSettingArr(mappedSettingList);
            setSelectedSetting(mappedSettingList.filter((el: SingleSelectedChannel) => el.value === pollData?.settingId)[0])
        }
    }, [editModal, pollData?.dateTo])

    const customStyles = {
        indicatorsContainer: () => ({
            backgroundColor: '#e10626',
            borderRadius: '50%',
            marginLeft: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }),
        control: () => ({
            display: 'flex',
            padding: '5px 13px 5px 13px',
            backgroundColor: '#eff1f6',
            border: '1px solid #cacaca',
            borderRadius: '20px',
            fontSize: '18px',
            fontWeight: '500',
            color: '#555454'
        }),
        dropdownIndicator: () => ({
            color: 'white',
            padding: '5px 7px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    }


    const editPoll = () => {

        if (poll.dateFrom && poll.dateTo && poll.votingFrom && poll.votingTo && poll.name && selectedSetting && poll.id) {

            API.editPoll({ ...poll, settingId: selectedSetting!.value })
                .then(res => {
                    openModal(false);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err.response.data.Exception);
                })
        } else {
            setLoading(false);
            setError('Należy uzupełnić wszystkie pola!');
        }
    }

    return (
        <>
            <form>
                <div className={style.addPoll__row}>
                    <label
                        htmlFor="start"
                        className={style.addPoll__formLabel}
                    >
                        Data od:
                    </label>
                    <input
                        className={style.addPoll__formInput}
                        type="datetime-local"
                        id="start"
                        name="poll-start"
                        value={poll.dateFrom}
                        max="2032-06-22T00:00"
                        onChange={
                            (e) => {
                                setPoll({
                                    ...poll,
                                    dateFrom: e.target.value
                                })
                            }
                        }
                    />
                </div>
                <div className={style.addPoll__row}>
                    <label
                        htmlFor="end"
                        className={style.addPoll__formLabel}
                    >
                        Data do:
                    </label>
                    <input
                        className={style.addPoll__formInput}
                        type="datetime-local"
                        id="end"
                        name="poll-end"
                        value={poll.dateTo}
                        max="2032-06-22T00:00"
                        onChange={
                            (e) => {
                                setPoll({
                                    ...poll,
                                    dateTo: e.target.value
                                })
                            }
                        }
                    />
                </div>
                <div className={style.addPoll__row}>
                    <label
                        htmlFor="voatingStart"
                        className={style.addPoll__formLabel}
                    >
                        Głosowanie od:
                    </label>
                    <input
                        className={style.addPoll__formInput}
                        type="datetime-local"
                        id="voatingStart"
                        name="poll-voatingStart"
                        value={poll.votingFrom}
                        max="2032-06-22T00:00"
                        onChange={
                            (e) => {
                                setPoll({
                                    ...poll,
                                    votingFrom: e.target.value
                                })
                            }
                        }
                    />
                </div>
                <div className={style.addPoll__row}>
                    <label
                        htmlFor="voatingEnd"
                        className={style.addPoll__formLabel}
                    >
                        Głosowanie do:
                    </label>
                    <input
                        className={style.addPoll__formInput}
                        type="datetime-local"
                        id="voatingEnd"
                        name="poll-voatingEnd"
                        value={poll.votingTo}
                        max="2032-06-22T00:00"
                        onChange={
                            (e) => {
                                setPoll({
                                    ...poll,
                                    votingTo: e.target.value
                                })
                            }
                        }
                    />
                </div>
                <div className={style.addPoll__row}>
                    <label
                        htmlFor="voatingName"
                        className={style.addPoll__formLabel}
                    >
                        Nazwa:
                    </label>
                    <input
                        className={style.addPoll__formInput}
                        type="text"
                        id="voatingName"
                        name="poll-voatingName"
                        value={poll.name}
                        onChange={
                            (e) => {
                                setPoll({
                                    ...poll,
                                    name: e.target.value
                                })
                            }
                        }
                    />
                </div>
                <div className={style.addPoll__row}>
                    <Select
                        value={selectedSetting}
                        onChange={(e) => {
                            setSelectedSetting(e)
                        }}
                        options={settingArr}
                        placeholder={"Wybierz ustawienie"}
                        styles={customStyles}
                    />
                </div>
                <div className={style.addPoll__row}>
                    {!loading ? <input
                        type="button"
                        value="EDYTUJ"
                        className={style.AddCathegory__button}
                        onClick={(e) => {
                            e.preventDefault();
                            setLoading(true);
                            editPoll();
                        }}
                    /> : <p className={style.loader}>Trwa dodawanie...</p>
                    }
                </div>
                {error &&
                    <div className={style.addPoll__row}>
                        <p className={style.errorText}>{error}</p>
                    </div>
                }
            </form>
        </>
    )
}

export default EditPollModal;